import { PropertyImage } from '../../../../../services/dtos/property';

export default function toSrcSetData(image: PropertyImage) {
  const { small, medium, large } = image;

  if (!small && !medium && !large) {
    return null;
  }

  return {
    srcSet: `${small} 400w, ${medium} 800w, ${large} 1200w`,
    sizes: '400px 800px 1200px',
  };
}
